import React from 'react'
import Video2 from '../assets/video/video2.mp4';
import AboutSvg1 from '../assets/images/svg/about-svg1.svg';
import AboutSvg2 from '../assets/images/svg/about-svg2.svg';
import AboutSvg3 from '../assets/images/svg/about-svg3.svg';
import AboutSvg4 from '../assets/images/svg/about-svg4.svg';
import AboutImg1 from '../assets/images/about/about-img1.jpg';
import CheckTransparent from '../assets/images/svg/check-transparent.svg';
import HowWorkBg from '../assets/images/about/how-to-work-bg.png';
import HowWorkSvg1 from '../assets/images/svg/how-to-work-svg1.svg';
import HowWorkSvg2 from '../assets/images/svg/how-to-work-svg2.svg';
import HowWorkSvg3 from '../assets/images/svg/how-to-work-svg3.svg';
import HowWorkArrow from '../assets/images/svg/how-to-work-arrow.svg';
import HomeHeroSlider from '../component/HomeHeroSlider';
import ServicesFeatured from '../component/ServicesFeatured';
import CostCalculator from '../component/CostCalculator';
import TeamSection from '../component/TeamSection';
import BlogSec1 from '../component/BlogSec1';
import ImageZoomScroll from '../component/ImageZoomScroll';



const HomeSlider: React.FC = () => {
    return (
        <>
            {/* <!-- ====================================== Section Hero Slider ===================================== --> */}
            <section className="hero-slider-section">
                <HomeHeroSlider />
            </section>
            {/* <!-- ====================================== Section Two ===================================== --> */}
            <section className="section-two" id="o-nas">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6">
                            <p className="cap-text fade_in">o SprzątAsia</p>
                            <h2 className="sec-text fade_up">My zajmujemy się bałaganem – Ty cieszysz się czystością</h2>
                            <p className="sec-sub-text fade_up">SprzątAsia to aplikacja, która łączy Cię z profesjonalnymi serwisami sprzątającymi w Twojej okolicy. Rezerwujesz online, my przyjeżdżamy punktualnie i sprzątamy dokładnie – każdy kąt, za każdym razem.</p>
                            <div className="about-grid-box-main">
                                <div className="about-box-main zoom_in">
                                    <div className="about-svg-main">
                                        <img src={AboutSvg1} alt="about-svg1" />
                                    </div>
                                    <div>
                                        <h3 className="expeStaff">Doświadczony zespół</h3>
                                        <p className="fessional">Zweryfikowani i przeszkoleni specjaliści gotowi do pracy w każdym miejscu.</p>
                                    </div>
                                </div>
                                <div className="about-box-main zoom_in">
                                    <div className="about-svg-main">
                                        <img src={AboutSvg2} alt="about-svg2" />
                                    </div>
                                    <div>
                                        <h3 className="expeStaff">Bezpieczne środki</h3>
                                        <p className="fessional">Stosujemy wyłącznie certyfikowane środki czystości, bezpieczne dla dzieci i zwierząt.</p>
                                    </div>
                                </div>
                                <div className="about-box-main zoom_in">
                                    <div className="about-svg-main">
                                        <img src={AboutSvg3} alt="about-svg3" />
                                    </div>
                                    <div>
                                        <h3 className="expeStaff">Szybka realizacja</h3>
                                        <p className="fessional">Ustal harmonogram i korzystaj z regularnego sprzątania bez żadnych komplikacji.</p>
                                    </div>
                                </div>
                                <div className="about-box-main zoom_in">
                                    <div className="about-svg-main">
                                        <img src={AboutSvg4} alt="about-svg4" />
                                    </div>
                                    <div>
                                        <h3 className="expeStaff">Najlepszy sprzęt</h3>
                                        <p className="fessional">Używamy profesjonalnego sprzętu klasy premium, który zapewnia doskonałe rezultaty.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 position-relative">
                            <svg style={{ position: 'absolute', width: 0, height: 0 }} aria-hidden="true">
                                <defs>
                                    <clipPath id="about-wipe-shape" clipPathUnits="objectBoundingBox">
                                        <ellipse cx="0.55" cy="0.20" rx="0.43" ry="0.20"/>
                                        <ellipse cx="0.46" cy="0.50" rx="0.45" ry="0.22"/>
                                        <ellipse cx="0.53" cy="0.80" rx="0.42" ry="0.20"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <div className="sub-img-main">
                                <div className="about-wipe-frame">
                                    <img className="about-img1" src={AboutImg1} alt="about-img1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section Three ===================================== --> */}
            <section className="section-three" id="uslugi">
                <div className="container">
                    <p className="cap-text fade_up">NASZE USŁUGI</p>
                    <div className="section-main-text-flex">
                        <h2 className="sec-text pb-0 fade_up">Kompleksowe sprzątanie dla każdej przestrzeni</h2>
                        <p className="sec-sub-text ornare fade_up">Oferujemy szeroki zakres usług sprzątania – od domów i mieszkań po biura, okna i klatki schodowe. Dobieramy metodę i środki do każdego zlecenia.</p>
                    </div>
                    <ServicesFeatured />
                </div>
            </section>
            {/* <!-- ====================================== Section Four ===================================== --> */}
            <section className="section-four">
                <div className="container">
                    <div className="row why-choose-row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6">
                            <p className="cap-text fade_up">dlaczego my</p>
                            <h2 className="sec-text fade_up">Sprawimy, że każde miejsce będzie czyste, schludne i świeże.</h2>
                            <p className="sec-sub-text fade_up">Wybierając SprzątAsia, wybierasz spokój ducha. Nasz team jest w pełni ubezpieczony, zweryfikowany i przeszkolony. Gwarantujemy satysfakcję lub bezpłatne ponowne sprzątanie.</p>
                            <div className="check-box-main">
                                <div className="check-box-main-sub fade_up">
                                    <img src={CheckTransparent} alt="check-transparent" />
                                    <div>
                                        <h2>Opinie klientów</h2>
                                        <p>Ponad 2000 pozytywnych opinii w aplikacji. Nasi klienci wracają do nas, bo wiedzą, że zawsze dostarczamy to, co obiecujemy.</p>
                                    </div>
                                </div>
                                <div className="check-box-main-sub fade_up">
                                    <img src={CheckTransparent} alt="check-transparent" />
                                    <div>
                                        <h2>Jesteśmy rzetelni</h2>
                                        <p>Punktualność, dokładność i szacunek do Twojego domu to nasze priorytety. Zawsze zostawiamy po sobie porządek i czystość.</p>
                                    </div>
                                </div>
                                <div className="check-box-main-sub fade_up">
                                    <img src={CheckTransparent} alt="check-transparent" />
                                    <div>
                                        <h2>Sprzątanie cykliczne</h2>
                                        <p>Dostępne plany tygodniowe, dwutygodniowe i miesięczne. Stały team i atrakcyjne ceny dla stałych klientów.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 sec-video2">
                            <video autoPlay muted loop playsInline className="video2">
                                <source src={Video2} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            <div className="sadas"></div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section Five ===================================== --> */}
            <section className="section-five">
                <div className="container">
                    <p className="cap-text cost-cal fade_up">Kalkulator kosztów</p>
                    <h2 className="sec-text fami-cal pb-0 fade_up">Dołącz do setek zadowolonych rodzin.</h2>
                    <div className="calculator-box-main zoom_in">
                        <CostCalculator />
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section Six ===================================== --> */}
            <section className="section-six" id="jak-to-dziala">
                <div className="container position-relative">
                    <img className="how-to-work-bg" src={HowWorkBg} alt="how-to-work-bg" />
                    <p className="cap-text cost-cal position-relative fade_up">Jak to działa</p>
                    <h2 className="sec-text mazing position-relative fade_up">Profesjonalne sprzątanie w 3 prostych krokach</h2>
                    <p className="sec-sub-text scetur position-relative fade_up">Rezerwacja przez SprzątAsia jest prosta i szybka. Wybierz usługę, zaplanuj termin i zostaw resztę nam. Nasz team zajmie się wszystkim od A do Z.</p>
                    <div className="how-work-step-box">
                        <div className="how-work-step-box-sub fade_up">
                            <div className="how-to-work-circle">
                                <img src={HowWorkSvg1} alt="how-to-work-svg1" />
                            </div>
                            <h3>Wybierz usługę</h3>
                            <p className="fessional send-info">Przeglądaj nasze usługi w aplikacji i wybierz pakiet, który najlepiej odpowiada Twoim potrzebom.</p>
                        </div>
                        <div className="how-work-step-box-sub how-to-work-arrow">
                            <div>
                                <img src={HowWorkArrow} alt="how-to-work-arrow" />
                            </div>
                        </div>
                        <div className="how-work-step-box-sub fade_up">
                            <div className="how-to-work-circle">
                                <img src={HowWorkSvg2} alt="how-to-work-svg2" />
                            </div>
                            <h3>Zaplanuj termin</h3>
                            <p className="fessional send-info">Wybierz wygodny dla siebie dzień i godzinę. Potwierdzenie rezerwacji otrzymasz natychmiast.</p>
                        </div>
                        <div className="how-work-step-box-sub how-to-work-arrow">
                            <div>
                                <img src={HowWorkArrow} alt="how-to-work-arrow" />
                            </div>
                        </div>
                        <div className="how-work-step-box-sub fade_up">
                            <div className="how-to-work-circle">
                                <img src={HowWorkSvg3} alt="how-to-work-svg3" />
                            </div>
                            <h3>Ciesz się czystością</h3>
                            <p className="fessional send-info">Przyjedziemy punktualnie i sprzątamy dokładnie. Po zakończeniu oceń naszą pracę w aplikacji.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- ====================================== Section Eight ===================================== --> */}
            <section className="section-eight pt-0">
                <div className="container">
                    <p className="cap-text cost-cal fade_up">Nasz zespół</p>
                    <h2 className="sec-text mazing pb-0 fade_up">Profesjonaliści, którym możesz zaufać</h2>
                    <TeamSection limit={4} />
                </div>
            </section>

            {/* <!-- ====================================== Section Blog ===================================== --> */}
            <section className="blog-section" id="kontakt">
                <div className="container">
                    <p className="cap-text cost-cal fade_up">aktualności</p>
                    <h2 className="sec-text mazing pb-0 fade_up">Ostatnie artykuły na blogu</h2>
                    <div className="container">
                        <BlogSec1 limit={3} />
                    </div>
                </div>
            </section>
            <ImageZoomScroll />

        </>
    )
}

export default HomeSlider
